import type { TimelineTranslations } from "../../types/timeline";

export const timeline: TimelineTranslations = {
  loading: "Loading timeline...",
  failedLoad: "Failed to load timeline",
  noDocuments: "No documents found",
  uploadPrompt: "Upload a document to see it on the timeline",
  documentCount: "{count} documents",
  showingCount: "(showing {count})",
  loadMore: "Load more documents",
  hintZoomScroll: "Tip: Hold Cmd/Ctrl and scroll to zoom",
  hintZoomScrollInfinite:
    "Tip: Hold Cmd/Ctrl and scroll to zoom. Scroll down to load more documents.",
  loadingDocuments: "Loading documents...",
  documentsOfTotal: "{loaded} of {total} documents",
  loadingMore: "Loading more...",
  selectDocument: "Select document {filename}",
  viewDocument: "View {filename}",
  addedBy: "Added by {name}",
  uploaded: "Uploaded",
  downloadDocument: "Download {filename}",
  zoomOut: "Zoom out",
  zoomLevelAriaLabel: "Timeline zoom level",
  zoomIn: "Zoom in",
  documentSingular: "document",
  documentPlural: "documents",
  clusterDocumentsOf: "{loaded} of {total} documents",
  clusterAriaLabel: "{count} documents from {dateRange}, click to {action}",
  clusterActionExpand: "expand",
  clusterActionView: "view",
  dateBasis: {
    label: "Date",
    upload: "Upload",
    creation: "Creation",
    uploadTooltip:
      "Place documents by when they were uploaded to Franklin — the platform's own upload date and time.",
    creationTooltip:
      "Place documents by the creation or modification date stored in each file's metadata. Files that record no date are placed by their upload date.",
    uploadUnavailableTooltip:
      "Placing documents by upload date is not available yet. It will appear after the next platform update.",
  },
  zoomGranularity: {
    years: "Years",
    months: "Months",
    weeks: "Weeks",
    days: "Days",
    hours: "Hours",
    minutes: "Minutes",
  },
  granularitySummary: {
    year: "{count} years",
    month: "{count} months",
    week: "{count} weeks",
    day: "{count} days",
  },
  viewMode: {
    list: "List",
    listAriaLabel: "List view",
    timeline: "Timeline",
    timelineAriaLabel: "Timeline view",
  },
};
